
import { Component, EventEmitter, Injector, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { CategorieModel } from 'src/app/shared/models/simple-types/categorie.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { CategorieService } from 'src/app/shared/services/simple/categorie.service';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { NaService } from 'src/app/shared/services/simple/na.service';
import { ActiviteModel } from 'src/app/shared/models/simple-types/activite.model';
import { ActiviteService } from 'src/app/shared/services/simple/activite.service';
import { DestinationModel } from 'src/app/shared/models/simple-types/destination.model';
import { DestinationService } from 'src/app/shared/services/simple/destination.service';
import { DestinationDTO } from 'src/app/shared/dtos/destinationDTO';
import { ModalChargementComponent } from 'src/app/shared/components/modals/modal-chargement/modal-chargement.component';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';

@Component({
  selector: 'app-gestion-destination',
  templateUrl: './gestion-destination.component.html',
  styleUrls: ['./gestion-destination.component.scss']
})
export class GestionDestinationComponent {

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();
  activite: ActiviteModel;
  mySubscription: any;
  result = false;
  loading = false;
  displayedColumns: string[] = ['categorie', 'destination1', 'destination3', 'destination2'];
  dataSource: CategorieModel[];
  matDataSource = new MatTableDataSource<DestinationDTO>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'categorie', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  destinations: DestinationDTO[] = [];
  activites: ActiviteModel[] = [];
  nas: NaModel[] = [];
  droitLevel = 0;
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private destinationService: DestinationService,
    private activiteService: ActiviteService,
    private naService: NaService
  ){}

  ngOnInit(): void {
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'categorie';
    this.matDataSource.paginator = this.paginator;
    this.activiteService.getAll().subscribe(types => {
      this.activites = types;
    });
    this.naService.getAll().subscribe(types => {
      this.nas = types;
    });
  }

  onChange(activite): void {
    if(activite){
      const dialogRef = this.dialog.open(SpinnerModalComponent);
      this.destinationService.getDestinationDTOFromActivite(activite.id).subscribe(types => {
        this.destinations = types;
        this.length = this.destinations.length;
        this.matDataSource = new MatTableDataSource<DestinationDTO>(this.destinations);
        dialogRef.close();
      }, error => { dialogRef.close();});
    }else {
      this.destinations = [];
      this.length = this.destinations.length;
      this.matDataSource = new MatTableDataSource<DestinationDTO>(this.destinations);
    }
  }

  enregistrer(): void {
    const destinationsDTO = this.destinations;
    const dialogRef = this.dialog.open(SpinnerModalComponent);
    this.destinationService.updateDestinations(destinationsDTO).subscribe(res => {
      this.destinations = res;
      dialogRef.close();
      this.toastr.success('Enregitrement des modifications', 'Modification réussie.');
    });
      
  }


  orderUsers(categories: CategorieModel[]): CategorieModel[] {
    categories = categories.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return categories;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
  }



  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
  }

}
